export const PHONE_PATTERN = /^((0|\+370)\d{8})?$/;
export const PHONE_VALIDATION_PATTERN = /^((0|\+370)\d{8})?$/.source;
export const PHONE_VALIDATION_INTERNATIONAL_PATTERN = /^(\+3706\d{7})?$/.source;
export const PHONE_VALIDATION_ANY_COUNTRIES = /^\+?\d{1,4}[\s.-]?\d{6,14}$/.source;
export const SHORT_PHONE_PATTERN = /^(6\d{7})?$/.source;
